import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';
import './styles.css'
import ColorPicker from './components/ColorPicker';


function App() {
  return (
    <div>
      <ColorPicker />
   </div>
  );
}

export default App;
